import animation, { fadeInUp } from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;

  > img {
    display: block;
    width: 100%;
    will-change: filter;
    transition: filter 375ms ${animation.easeInOutCubic};
  }
`;

const Overlay = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 20px;

  @media ${from(600)} {
    transform: translateY(64px);
    will-change: transform;
    transition: transform 375ms ${animation.easeInOutCubic};
  }
`;

const Card = styled.a<{ cardInView: boolean; delay: number }>`
  --vertical-indent: 0px;
  --margin-bottom: 20px;

  display: block;
  height: 100%;
  position: relative;
  padding-bottom: 144.5%;
  border-radius: 8px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: var(--margin-bottom);

  @media ${from(600)} {
    --vertical-indent: 46px;
    --margin-bottom: calc(var(--vertical-indent) / 3);
  }

  ${({ cardInView, delay }) => fadeInUp(cardInView, 25, 500, delay, animation.easeInOutCubic)};

  &:nth-child(odd) {
    top: var(--vertical-indent);
  }

  &:last-child {
    margin-bottom: 0px;

    @media ${from(600)} {
      margin-bottom: inherit;
    }
  }

  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(transparent 0%, #000 80%);
    pointer-events: none;
  }

  &:hover {
    @media ${from(600)} {
      ${ImageWrapper} img {
        filter: grayscale(0.75);
      }

      ${Overlay} {
        transform: translateY(0px);
      }
    }
  }
`;

const Icon = styled.img`
  display: block;
  margin: 0 auto 18px;
  max-width: 200px;
`;

const Text = styled.h4`
  color: ${brand.white};
  ${fonts.helvetica['83-heavy-extended']};
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  max-width: 268px;
  margin: 0 auto;

  @media ${from(Device.Desktop)} {
    font-size: 16px;
    line-height: 20px;
  }
`;

const Button = styled.div`
  margin-top: 16px;
`;

export const TradeCardStyles = { ImageWrapper, Overlay, Card, Icon, Text, Button };
